module.exports = __webpack_public_path__ + "static/media/img_leftpanel.28aa1f4f.jpg";